import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [RouterModule.forRoot([
    {
      path: '',
      loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule)
    },
    {
      path: '',
      loadChildren: () => import('./modules/authenticated/authenticated.module').then(m => m.AuthenticatedModule),
    },
    { path: 'unauthorized', redirectTo: '/' },
  ], {
    anchorScrolling: 'enabled',
    enableTracing: false,
    onSameUrlNavigation: 'reload',
    scrollOffset: [0, 50],
    scrollPositionRestoration: 'enabled',
    paramsInheritanceStrategy: 'always',
    bindToComponentInputs: true,
  })],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
